// extracted by mini-css-extract-plugin
export default {"container":"Fl-z","title":"Gl-z","linkContainer":"Hl-z","viewItemLink":"Il-z"};